import { useSelectedCardBrand } from '@tectonics/look-and-feel/commons/selected-card-brand';
import type { CardBrand } from '@tectonics/prs/card-brand';

const AMEX_SECURITY_CODE_LENGTH = 4;
const DEFAULT_SECURITY_CODE_LENGTH = 3;

function getSecurityCodeLength(cardBrand: CardBrand | null | undefined): number {
  return cardBrand === 'amex' ? AMEX_SECURITY_CODE_LENGTH : DEFAULT_SECURITY_CODE_LENGTH;
}

function useCardBrand(): { cardDigits: number, cardBrand?: CardBrand | null } {
  const cardBrand = useSelectedCardBrand();
  const cardDigits = getSecurityCodeLength(cardBrand);

  return { cardDigits, cardBrand };
}

export { useCardBrand };
